module.exports = __webpack_public_path__ + "static/media/STHiFi6.977a8030.png";